const XYZ_DIMENSIONS = ['x', 'y', 'z'];
const ZERO_VECTOR = { x: 0, y: 0, z: 0 };
// The default unit vector is pointing backwards in the z-direction
const DEFAULT_UNIT_VECTOR = { x: 0, y: 0, z: -1 }; // Used as the default unit vector when a direction vector has zero magnitude
/**
 * Returns the magnitude of a vector with x, y, and z coordinates
 *
 * @param vector - A vector with x, y, and z coordinates
 * @param vector.x - The x coordinate of the vector
 * @param vector.y - The y coordinate of the vector
 * @param vector.z - The z coordinate of the vector
 * @returns the magnitude of the vector computed as the square root of the sum of the squares of its coordinates
 */
export const computeVectorMagnitude = ({ x, y, z }) => Math.sqrt(x * x + y * y + z * z);
/**
 * Returns the normalized unit vector in the provided direction
 *
 * @param directionVector - A vector in the direction of interese
 * @returns the normalized unit vector in the provided direction or a default vector of { x: 0, y: 0, z: -1 } if the magnitude is zero
 */
export const getDirectedUnitVector = (directionVector) => {
    const magnitude = computeVectorMagnitude(directionVector);
    return magnitude > 0
        ? {
            x: directionVector.x / magnitude,
            y: directionVector.y / magnitude,
            z: directionVector.z / magnitude
        }
        : { ...DEFAULT_UNIT_VECTOR };
};
/**
 * Returns the sum vector of the provided vectors with XYZ coordinates
 *
 * @param vectors - Array of vectors to be added (partial vectors are allowed)
 * @returns the sum of the vectors
 * @remarks if no vectors are provided, returns a zero vector
 */
export const addVectors = (vectors) => vectors.reduce((sumVector, vector) => {
    for (const dimension of XYZ_DIMENSIONS) {
        sumVector[dimension] += vector[dimension] ?? 0;
    }
    return sumVector;
}, { ...ZERO_VECTOR });
//# sourceMappingURL=vectorUtils.js.map